import React, { useState } from 'react';
import TopBadges from './TopBadges';
import Button from '../shared/Button';
import { useDispatch } from 'react-redux';
import { addItemToBucket } from '../features/bucket/bucketSlice';
import ItemModal from './modals/ItemModal';

const ItemCard = ({ data }) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };


  const addToBucket = () => {
    console.log(data)
    dispatch(addItemToBucket(data));
  };

  return (
    <>
      <div className="flex rounded-[15px]  relative min-h-[370px] pb-[10px] px-[12px] bg-white  flex-col shadow-lg">
        <TopBadges />
        <img
          src={data.image}
          alt="Seller"
          onClick={openModal}
          className="hover:transform hover:scale-110 cursor-pointer transition-transform duration-500 ease-in-out"
        />
        <h2 className="font-bold text-xl text-black">{data.title}</h2>
        <p className="text-sm">
          {data.description.length > 60 ? `${data.description.slice(0, 60)}...` : data.description}
        </p>
        <h4 className="font-semibold">Rs. {data.price}</h4>
        <div className="flex justify-center mt-8">
          <Button
            data="+ ADD TO BUCKET"
            type="solid"
            styles="min-w-[50%] text-sm absolute bottom-[-15px] flex justify-center px-2 hover:bg-white hover:text-light-secondary cursor-pointer hover:border-2 hover:border-light-secondary"
            onClick={addToBucket}
          />
        </div>
      </div>
      {isModalOpen && (
        <ItemModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} data={data} />
      )}
    </>
  );
};

export default ItemCard;
